import React from "react";
import "../style/Footer.scss";
import footerImg from "../assets/images/pc/04_Footer.png";
import joinImg from "../assets/images/pc/05_Jointhemovement.png";
import logoImg from "../assets/images/Logo_White.png";

function Footer(props) {
  const onClickNav = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div id={"Footer"}>
      <img className="footer-img" src={footerImg} alt="footer image" />
      <div className="footer-container">
        <div className="footer-content-wrapper">
          <div className="text-img-wrapper">
            <img src={logoImg} alt="" className="logo-img" />
          </div>
          <div className="footer-button-wrapper">
            <div className="footer-button">
              <div onClick={() => onClickNav("Section1")} className="footer-button-text">
                TECH SPECS
              </div>
            </div>
            <div className="footer-button">
              <div onClick={() => onClickNav("Section2")} className="footer-button-text">
                TOKENOMICS
              </div>
            </div>
            <div className="footer-button">
              <div onClick={() => onClickNav("Section3")} className="footer-button-text">
                GO TO MARKET
              </div>
            </div>
            <div className="footer-button">
              <div onClick={() => onClickNav("Section4")} className="footer-button-text">
                TIMELINE
              </div>
            </div>
            <div className="footer-button">
              <div onClick={() => onClickNav("Section5")} className="footer-button-text">
                TEAM
              </div>
            </div>
          </div>
        </div>
        <img src={joinImg} className="footer-box-img" alt="join the movement" />
      </div>
    </div>
  );
}

export default Footer;
